define('companiesListFiltersView',[
  'module',
  'backbone',
  'underscore',
  'settings',
  'companiesListFiltersEditView',
  'companiesListFiltersQuickAccessView',
  'filtersBannerView'
], function (
  Module,
  Backbone,
  _,
  Settings,
  EditView,
  QuickAccessView,
  FiltersBannerView
) {
  'use strict';

  var FILTERS_COOKIE = 'companiesListFilters';

  // Companies list filter, built on the same "filters banner" component as the
  // orders/offers list: a clickable banner that opens an edit popup, inline
  // quick-access inputs, and a pill per active filter. Values are persisted in
  // a cookie so they survive navigation/reload.
  Module.exports = FiltersBannerView.extend({
    editViewClass: EditView,
    quickAccessViewClass: QuickAccessView,

    initialize: function () {
      this.tableView = this.options.tableView;

      var attrs = { name: '', emailDomain: '', countryCode: '' };
      var saved = Settings.get(FILTERS_COOKIE, true);
      if (saved) {
        try {
          _.extend(attrs, JSON.parse(saved));
        } catch (e) {
          // ignore a corrupt cookie
        }
      }
      this.model = new Backbone.Model(attrs);
      // The shared table passes this model to fetch()/fetchCount() as `filters`.
      this.tableView.filters = this.model;

      FiltersBannerView.prototype.initialize.apply(this, arguments);
    },

    // One pill per active filter (shown in the banner).
    setCollection: function () {
      if (this.model.get('name')) {
        this.collection.add(new Backbone.Model({
          id: 'name', libelle: _.i18n('common.name'), value: this.model.get('name')
        }));
      }
      if (this.model.get('emailDomain')) {
        this.collection.add(new Backbone.Model({
          id: 'emailDomain', libelle: _.i18n('companies.emailDomain', null, 'Email domain'), value: this.model.get('emailDomain')
        }));
      }
      if (this.model.get('countryCode')) {
        this.collection.add(new Backbone.Model({
          id: 'countryCode', libelle: _.i18n('common.countryCode'), value: this.model.get('countryCode')
        }));
      }
      FiltersBannerView.prototype.setCollection.apply(this, arguments);
    },

    fetch: function (model) {
      var changed = this.model.get('name') !== model.get('name') ||
        this.model.get('emailDomain') !== model.get('emailDomain') ||
        this.model.get('countryCode') !== model.get('countryCode');

      FiltersBannerView.prototype.fetch.apply(this, arguments);
      Settings.set(FILTERS_COOKIE, JSON.stringify(this.model.attributes), true);

      if (changed) {
        // Filtering changes the result set: back to page 1, refetch rows + count.
        this.tableView.bodyView.first = 0;
        if (this.tableView.footerView) {
          this.tableView.footerView.currentPage = 1;
        }
        this.tableView.bodyView.fetch();
        if (this.tableView.footerView) {
          this.tableView.footerView.fetch();
        }
      }
    }
  });
});

